import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './dropdown.module.scss';

const Dropdown = forwardRef(
  (
    {
      options = [],
      errorMessage,
      className = '',
      onChange,
      defaultValue,
      elevation = false,
    },
    ref
  ) => {
    const [inFocus, setInFocus] = useState(false);
    const handleOnFocus = () => setInFocus(true);
    const handleOnBlur = () => setInFocus(false);
    const handleOnChange = (e) => {
      const selectedValue = e.currentTarget.value;
      if (onChange) {
        onChange(options.find((option) => option.value === selectedValue));
      }
    };

    const wrapperHasErrorClassName = errorMessage ? styles.errorWrapper : '';
    const wrapperInFocusClassName = inFocus ? styles.focusWrapper : '';
    const hasElevation = elevation ? styles.shadow : '';
    // const homePrequalDropdown = className ? styles.homePrequalDropdown : '';
    const homePrequalDropdown =
      className === 'heroHomeDropdown' ? styles.homePrequalDropdown : '';
    const compoundClassName = `${styles.wrapper} ${className} ${wrapperHasErrorClassName} ${wrapperInFocusClassName} ${hasElevation} ${homePrequalDropdown}`;

    return (
      <div className={compoundClassName}>
        {errorMessage && (
          <span error-span="loan-purpose-error" className={styles.errorText}>
            {errorMessage}
          </span>
        )}
        <span className={styles.icon} />
        <select
          data-testid="loan-purpose"
          aria-label="loan purpose"
          className={styles.select}
          ref={ref}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          value={defaultValue}
        >
          {options.length > 0
            ? options?.map((option) => (
                <option
                  key={option?.value}
                  className={styles.option}
                  value={option?.value}
                >
                  {option?.text}
                </option>
              ))
            : null}
        </select>
      </div>
    );
  }
);

Dropdown.displayName = 'Dropdown';

const options = PropTypes.shape({
  value: PropTypes.string,
  text: PropTypes.string,
});

Dropdown.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(options),
  errorMessage: PropTypes.string,
  defaultValue: PropTypes.string,
  elevation: PropTypes.bool,
};

export default Dropdown;
